<!-- <app-scroller_section-type01 [options]="{showMembers:true}"></app-scroller_section-type01> -->

<section class="w-full border-b-2 border-primary-500 pb-6">
    <div class="relative flex flex-col items-center max-w-screen-xl px-4 mx-auto md:flex-row">
        <div class="max-w-5xl mx-auto py-16 mr-5">
            <div class="text-center space-y-5">
                <h2 class="font-semibold text-4xl text-primary-500 tracking-wide uppercase">{{view.heading}} <span class="text-4xl tracking-wide text-accent-500">your</span> {{view.title}}</h2>
                <div class="inline-flex items-end justify-center w-full text-center mx-auto">
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform translate-x-24 ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Aggregators'" [svgIcon]="'mat_solid:trending_up'"></mat-icon>
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform -translate-x-24 -ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Transfers'" [svgIcon]="'mat_solid:airport_shuttle'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform -translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Cruises'" [svgIcon]="'mat_solid:directions_boat_filled'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Car Hire'" [svgIcon]="'mat_solid:directions_car'"></mat-icon>
                    <mat-icon class="icon-size-12 text-primary-500 bg-accent-500 rounded-full w-20 h-20 md:w-24 md:h-24 border-4 border-white relative" [matTooltip]="'Flights'" [svgIcon]="'airplanemode_active'"></mat-icon>
                </div>
    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl dark:text-gray-200">{{view.tagline}}
                    <span class="px-2 py-1 relative inline-block">
                        <span class="relative tracking-wider text-4xl dark:text-gray-200" [innerHTML]="view.tagline2"></span>
                        <img src="assets/xltravel/swoosh-01.svg" alt="xl underline">
                    </span>
                </p>
    
                <p class="max-w-3xl mt-5 mx-auto text-xl text-gray-500" [innerHTML]="view.text"></p>
    
                @if (view.url && view.url.href && view.url.text) {
                <div class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center">
                    <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                        <button [routerLink]="view.url.href" class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-800">{{view.url.text}}</button>
                    </div>
                </div>
                }
            </div>
            
        </div>
        <div class="md:flex flex-col md:w-1/2 px-10 hidden">
            @if (view.options.showMap) 
            {
            <!-- <app-map-type01 [size]="'sm'" [zoom]="4" [disableUI]="true"></app-map-type01> -->
             <app-map-type01 [size]="'sm'" [zoom]="4" [disableUI]="true" [locations]="view.locations" [defaultLat]="view.defaultLat" [defaultLng]="view.defaultLng"></app-map-type01>
            }
            @if (view.options.showLogo) {
            <div class="relative w-full rounded">
                <div class="w-full">
                    <img src="/assets/images/logo/xl-logo-2.png" />
                </div>
            </div>
            }
            @if (view.options.showCarousel) {
            <ejs-carousel cssClass="" [showIndicators]="true" [buttonsVisibility]="'VisibleOnHover'"
                [partialVisible]="true">
                <e-carousel-items>

                    <e-carousel-item *ngFor="let item of view.carouselItems">
                        <ng-template #template>
                            <figure class="img-container mb-16">
                                <div class="w-full px-2">
                                    <img class="w-full"   [src]="item.src" [alt]="item.alt" />
                                </div>
                                <figcaption class="img-caption"></figcaption>
                            </figure>
                        </ng-template>
                    </e-carousel-item>
>
                    
                </e-carousel-items>
                <ng-template #previousButtonTemplate let-data>
                    <button type="button"
                        class="disabled:pointer-events-none absolute inset-y-0 start-0 inline-flex justify-center items-center w-[46px] h-full text-primary-800 focus:outline-none rounded-s-lg dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                        <span
                            class="text-2xl bg-primary-300 hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full"
                            aria-hidden="true">
                            <svg class="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6"></path>
                            </svg>
                        </span>
                        <span class="sr-only">Previous</span>
                    </button>
                </ng-template>
                <ng-template #nextButtonTemplate let-data>
                    <button type="button"
                        class="disabled:pointer-events-none absolute inset-y-0 end-0 inline-flex justify-center items-center w-[46px] h-full text-primary-800 focus:outline-none rounded-e-lg dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10">
                        <span class="sr-only">Next</span>
                        <span
                            class="text-2xl bg-primary-300 hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full"
                            aria-hidden="true">
                            <svg class="shrink-0 size-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </span>
                    </button>
                </ng-template>
                <ng-template #indicatorsTemplate let-data>
                    <div class="w-[80%] ">
                        <div class="hidden md:flex cursor-pointer w-28 h-12 mx-2 rounded-md b-2  border-primary-300"
                            [style.backgroundSize]="'cover'" [style.backgroundPosition]="'center'"
                            [style.backgroundImage]="'url(' + view.carouselItems[data.index].src + ')'"></div>
                    </div>
                </ng-template>
            </ejs-carousel>
            }
            
        </div>
    </div>
</section>
<!-- 
<section class="bg-white dark:bg-slate-800">
    <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        <div class="container mx-auto px-6 p-6 bg-white dark:bg-slate-800">
            <div class="mb-8 flex flex-col items-center justify-center text-center">
                <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Beyond the Ordinary</h4>
                <p class="mt-2 text-5xl lg:text-7xl font-bold tracking-tight text-gray-900 dark:text-white">XL <b>Corporate</b> Travel</p>
                <img class="w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
            </div>
            <div class="text-center space-y-5">                    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl dark:text-white">Customizable corporate travel programs.</p>
                <p>Our customizable corporate travel programs align seamlessly with your company's requirements, ensuring duty of care and effective risk management through automated travel advisories and alerts. We focus on delivering an exceptional client experience, guiding you from the initial requisition to post-travel support.</p>
            </div>
            <div class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center my-6">
                <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <button [routerLink]="/corporate-travel'" class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl dark:bg-slate-900">Find Out More</button>
                </div>
            </div>
            <div class="flex flex-wrap my-12">
                <app-deals-type01></app-deals-type01>
            </div>
        </div>
    </div>
</section> -->


<!-- 
<section class="w-full border-b-2 border-primary-500 pb-6 bg-white">
    <div class="relative flex flex-col items-center max-w-screen-xl px-4 mx-auto md:flex-row">
        <div class="max-w-5xl mx-auto py-16 mr-5">
            <div class="text-center space-y-5">
                <h2 class="font-semibold text-4xl text-primary-500 tracking-wide uppercase">{{view.heading}} <span class="text-4xl tracking-wide text-accent-500">your</span> XL TOOLS</h2>
                <div class="inline-flex items-end justify-center w-full text-center mx-auto">
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform translate-x-24 ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Aggregators'" [svgIcon]="'mat_solid:trending_up'"></mat-icon>
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform -translate-x-24 -ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Transfers'" [svgIcon]="'mat_solid:airport_shuttle'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform -translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Cruises'" [svgIcon]="'mat_solid:directions_boat_filled'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Car Hire'" [svgIcon]="'mat_solid:directions_car'"></mat-icon>
                    <mat-icon class="icon-size-12 text-primary-500 bg-accent-500 rounded-full w-20 h-20 md:w-24 md:h-24 border-4 border-white relative" [matTooltip]="'Flights'" [svgIcon]="'airplanemode_active'"></mat-icon>
                </div>
    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl dark:text-gray-200">Solutions that transform your business
                    <span class="px-2 py-1 relative inline-block">
                        <span class="relative tracking-wide text-4xl dark:text-gray-200"></span>
                        <img src="assets/xltravel/swoosh-01.svg" alt="xl underline">
                    </span>
                </p>
    
                <p class="max-w-3xl mt-5 mx-auto text-xl text-gray-500">Tools and solutions that change and adapt with you and your business.</p>
    
            </div>
            
        </div>
        <div class="flex flex-col md:w-1/2 px-10">
            <div class="relative w-full rounded">
                <div class="w-full">
                    <img src="/assets/images/logo/xl-logo-2.png" />
                </div>
            </div>        
            <div class="relative w-full rounded mt-10">
                <div class="w-full">
                    <img src="https://platform.travelfind.me/uploads/site/logo/xl-holidays-logo-no-tagline.png" />
                </div>
            </div>
        </div>
    </div>
</section> -->



<!-- <section class="w-full border-b-2 border-primary-500 pb-6">
    <app-counters-type01></app-counters-type01>
</section> -->
<!-- <section class="w-full border-b-2 border-primary-500">
    <div class="relative flex flex-col items-center max-w-screen-xl px-4 mx-auto md:flex-row">
        <div class="flex items-center md:w-1/2">
            <div class="relative w-full rounded">
                <div class="w-full">
                    <img src="/assets/images/logo/xl-holidays-logo.png" />
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto py-16">
            <div class="text-center space-y-5">
                <h2 class="font-semibold text-2xl text-primary-500 tracking-wide uppercase">You've arrived at <span class="text-4xl tracking-wide text-accent-500">your</span> info-hub</h2>
                <div class="inline-flex items-end justify-center w-full text-center mx-auto">
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform translate-x-24 ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Aggregators'" [svgIcon]="'mat_solid:trending_up'"></mat-icon>
                    <mat-icon class="icon-size-6 text-primary-500 bg-accent-500 absolute transform -translate-x-24 -ml-6 rounded-full w-12 h-12 md:w-16 md:h-16 border-4 border-white" [matTooltip]="'Transfers'" [svgIcon]="'mat_solid:airport_shuttle'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform -translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Cruises'" [svgIcon]="'mat_solid:directions_boat_filled'"></mat-icon>
                    <mat-icon class="icon-size-8 text-primary-500 bg-accent-500 absolute transform translate-x-16 rounded-full w-26 h-16 md:w-20 md:h-20 border-4 border-white" [matTooltip]="'Car Hire'" [svgIcon]="'mat_solid:directions_car'"></mat-icon>
                    <mat-icon class="icon-size-12 text-primary-500 bg-accent-500 rounded-full w-24 h-24 md:w-24 md:h-24 border-4 border-white relative" [matTooltip]="'Flights'" [svgIcon]="'airplanemode_active'"></mat-icon>
                </div>
    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl">Find information related to Suppliers, Our Technology, Marketing
                    <span class="px-2 py-1 relative inline-block">
                        <span class="relative tracking-wide text-4xl">and more!!</span>
                        <img src="assets/xltravel/swoosh-01.svg" alt="xl underline">
                    </span>
                </p>
    
                <p class="max-w-3xl mt-5 mx-auto text-xl text-gray-500">
                    Explore all the solutions we have to offer!
                </p>
    
                <div
                    class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center">
                        <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg">
                            <button [routerLink]="/our-solutions'" class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl">Click here to Start</button>
                        </div>
                </div>
            </div>
        </div>
        
    </div>
</section> -->



<!-- <section class="w-full border-b-2 border-primary-500 px-4 md:px-10 lg:px-10 xl:px-10">
    <div class="relative flex flex-col items-center max-w-screen-xl px-4 mx-auto md:flex-row">
        <div class="max-w-7xl mx-auto py-16">
            <div class="text-center space-y-5">
                <h2 class="font-semibold text-2xl text-primary-500 tracking-wide uppercase">XLGO travel app!</h2>
                    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl">Your travel companion and solution.</p>
                <p>XLGO serves a wide range of customers, including business and leisure travelers, online travelers, seasoned travelers, travelers on a budget,
                    and novice travelers. It provides an abundance of "fly" features along with extensive car duties that you haven't yet experienced.
                    Welcome to the brand-new XLGO, where you can now experience travel like never before!
                </p>
    
                <div
                    class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center">
                        <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg">
                            <button class="inline-flex items-center rounded-lg border border-gray-200 dark:text-white bg-gray-50  px-3 py-1.5 sm:px-4 sm:py-3 hover:bg-gray-100 focus:outline-none dark:bg-gray-800 dark:border-gray-600">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="h-7 w-5 sm:h-7 sm:w-9"
                                    viewBox="0 0 512 512">
                                    <path
                                        d="M99.617 8.057a50.191 50.191 0 00-38.815-6.713l230.932 230.933 74.846-74.846L99.617 8.057zM32.139 20.116c-6.441 8.563-10.148 19.077-10.148 30.199v411.358c0 11.123 3.708 21.636 10.148 30.199l235.877-235.877L32.139 20.116zM464.261 212.087l-67.266-37.637-81.544 81.544 81.548 81.548 67.273-37.64c16.117-9.03 25.738-25.442 25.738-43.908s-9.621-34.877-25.749-43.907zM291.733 279.711L60.815 510.629c3.786.891 7.639 1.371 11.492 1.371a50.275 50.275 0 0027.31-8.07l266.965-149.372-74.849-74.847z">
                                    </path>
                                </svg>
                                <div class="ml-2 flex flex-col items-start leading-none">
                                    <p class="mb-0 sm:text-xs text-[10px] text-gray-600 dark:text-gray-300">GET IT ON</p>
                                    <p class="title-font sm:text-sm text-xs font-medium dark:text-gray-200">Google Play</p>
                                </div>
                            </button>
                        </div>
                        <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg">
                            <button class="inline-flex items-center rounded-lg border border-gray-200 dark:text-white bg-gray-50 px-3 py-1.5 sm:px-4 sm:py-3 hover:bg-gray-100 focus:outline-none dark:bg-gray-800 dark:border-gray-600">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="h-7 w-5 sm:h-7 sm:w-9"
                                    viewBox="0 0 305 305">
                                    <path
                                        d="M40.74 112.12c-25.79 44.74-9.4 112.65 19.12 153.82C74.09 286.52 88.5 305 108.24 305c.37 0 .74 0 1.13-.02 9.27-.37 15.97-3.23 22.45-5.99 7.27-3.1 14.8-6.3 26.6-6.3 11.22 0 18.39 3.1 25.31 6.1 6.83 2.95 13.87 6 24.26 5.81 22.23-.41 35.88-20.35 47.92-37.94a168.18 168.18 0 0021-43l.09-.28a2.5 2.5 0 00-1.33-3.06l-.18-.08c-3.92-1.6-38.26-16.84-38.62-58.36-.34-33.74 25.76-51.6 31-54.84l.24-.15a2.5 2.5 0 00.7-3.51c-18-26.37-45.62-30.34-56.73-30.82a50.04 50.04 0 00-4.95-.24c-13.06 0-25.56 4.93-35.61 8.9-6.94 2.73-12.93 5.09-17.06 5.09-4.64 0-10.67-2.4-17.65-5.16-9.33-3.7-19.9-7.9-31.1-7.9l-.79.01c-26.03.38-50.62 15.27-64.18 38.86z">
                                    </path>
                                    <path
                                        d="M212.1 0c-15.76.64-34.67 10.35-45.97 23.58-9.6 11.13-19 29.68-16.52 48.38a2.5 2.5 0 002.29 2.17c1.06.08 2.15.12 3.23.12 15.41 0 32.04-8.52 43.4-22.25 11.94-14.5 17.99-33.1 16.16-49.77A2.52 2.52 0 00212.1 0z">
                                    </path>
                                </svg>
                                <div class="ml-2 flex flex-col items-start leading-none">
                                    <p class="mb-0 sm:text-xs text-[10px] text-gray-600 dark:text-gray-300">Download on the</p>
                                    <p class="title-font sm:text-sm text-xs font-medium dark:text-gray-200">App Store</p>
                                </div>
                            </button>
                        </div>
                </div>
            </div>
            <div class="w-full mt-5 items-center">
                <h4 class="text-center font-semibold text-xl">Some of the features includes:</h4>
                <div class="flex flex-wrap justify-center">
                    <ul class="grid grid-cols-2 md:grid-cols-4 gap-y-3 md:gap-y-0 mt-3">
                        <li class="flex">
                            <mat-icon class="text-primary-500 mr-2" svgIcon="heroicons_outline:map"></mat-icon>
                            <p class="text-gray-800 dark:text-gray-400">Maps and directions</p>
                        </li>
                        <li class="flex">
                            <mat-icon class="text-primary-500 mr-2" svgIcon="heroicons_outline:camera"></mat-icon>
                            <p class="text-gray-800 dark:text-gray-400">Social Media Sharing</p>
                        </li>
                        <li class="flex">
                            <mat-icon class="text-primary-500 mr-2" svgIcon="mat_solid:attach_money"></mat-icon>
                            <p class="text-gray-800 dark:text-gray-400">Expense Tracker</p>
                        </li>
                        <li class="flex">
                            <mat-icon class="text-primary-500 mr-2" svgIcon="heroicons_outline:hand-thumb-up"></mat-icon>
                            <p class="text-gray-800 dark:text-gray-400">and so much more...</p>
                        </li>
                    </ul>
                </div>   
            </div>
        </div>
        <div class="flex items-center md:w-1/2">
            <div class="relative w-full rounded">
                <div class="w-full">
                    <img src="/assets/images/logo/travel-app.png" />
                </div>
            </div>
        </div>
        
    </div>
</section> -->

<!-- <section class="bg-white  dark:bg-slate-800">
    <div class="max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
        <div class="container mx-auto px-6 p-6 bg-white  dark:bg-slate-800">
            <div class="mb-8 flex flex-col items-center justify-center text-center">
                <h4 class="text-base text-primry-600 font-semibold tracking-wide uppercase">Beyond the Ordinary</h4>
                <p class="mt-2 text-5xl lg:text-7xl font-bold tracking-tight text-gray-900 dark:text-white">XL <b>Rewards</b> Travel</p>
                <img class="w-100" src="assets/xltravel/swoosh-01.svg" alt="xl underline">
            </div>
            <div class="text-center space-y-5">                    
                <p class="mt-1 text-xl font-extrabold text-gray-900 sm:tracking-tight lg:text-2xl dark:text-white">Discounted rates and special promotions.</p>
                <p>Loyalty and reward programme designed to incentivise customers, offering benefits such as discounted rates and special promotions.</p>
            </div>
            <div class="flex flex-col sm:flex-row space-y-2.5 sm:space-y-0 sm:space-x-2.5 items-center justify-center my-6">
                <div class="flex max-w-sm rounded-xl bg-gradient-to-tr from-primary-500 to-accent-500 p-0.5 shadow-lg hover:transition-all delay-150 duration-300 ease-in-out">
                    <button [routerLink]="/rewards/rewards-page'" [queryParams]="{ type: 'rewards' }" class="flex-1 font-bold text-xl bg-white px-6 py-3 rounded-xl">Find Out More</button>
                </div>
            </div>
            <div class="flex flex-wrap my-6">
                
            </div>
        </div>
    </div>
</section> -->